export default __webpack_public_path__ + "static/media/neptik.b1efbf06.svg";